import { render, staticRenderFns } from "./CompanyMenuFoodCard.vue?vue&type=template&id=a3158638&scoped=true"
import script from "./CompanyMenuFoodCard.vue?vue&type=script&lang=js"
export * from "./CompanyMenuFoodCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyMenuFoodCard.vue?vue&type=style&index=0&id=a3158638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3158638",
  null
  
)

export default component.exports